import { useState, useEffect } from 'react'
import { WifiOff } from 'lucide-react'

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const onOffline = () => setOffline(true)
    const onOnline = () => setOffline(false)
    window.addEventListener('offline', onOffline)
    window.addEventListener('online', onOnline)
    return () => {
      window.removeEventListener('offline', onOffline)
      window.removeEventListener('online', onOnline)
    }
  }, [])

  if (!offline) return null

  return (
    <div className="flex items-center justify-center gap-2 px-4 py-2 bg-[var(--status-warning-bg)] border-b border-[var(--status-warning-border)] text-[var(--status-warning-text)] text-xs font-medium">
      <WifiOff className="h-3.5 w-3.5 shrink-0" />
      You're offline. Some features may not work.
    </div>
  )
}
